import type { FaireProductEntity } from "../../entity_types/product";

export const p_bpdyamc9mg: FaireProductEntity = {
  token: "p_bpdyamc9mg",
  type: "product",
  name: "Blue Calcite Raw",
  brandToken: "b_5wk9sqf7b2",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/b8d785b74e5c133dad5ca9d56aa9d932f066a33390a68dcc779e4dd5e4a1dad8.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5a72d879f398f40fb8ea49d7f0deffc0b10a144b0a8573162fe333097d93ca52.jpeg",
    "https://cdn.faire.com/fastly/4244a44b24b6e6115e5af43b402a7a0b084f10c671f39dca6729c58b2a88410c.jpeg",
    "https://cdn.faire.com/fastly/fb674ac4f2234f86c67d695d9b31dcfdfc7a203c12f4d58114ba0c96c8e051c9.jpeg",
  ],
  priceDollars: 2.77,
  description:
    "These are natural materials so your individual item may vary from the photos.\n\nMetaphysical Properties:\n\n * Promotes Emotional Healing \n * Brings Calmness \n * Aids in Mental Clarity \n * Restores Balance ",
  tags: [],
  msrpDollars: 5.54,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:17.486Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
